/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
/**
 * @class
 * @implements AuthenticationProviderOptions
 * Class representing MSALAuthenticationProviderOptions
 */
export class MSALAuthenticationProviderOptions {
    /**
     * @public
     * @constructor
     * To create an instance of MSALAuthenticationProviderOptions
     * @param {string[]} scopes - An array of scopes
     * @returns An instance of MSALAuthenticationProviderOptions
     */
    constructor(scopes) {
        this.scopes = scopes;
    }
}
//# sourceMappingURL=MSALAuthenticationProviderOptions.js.map